var React = require('react');

function Tractor60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57.856 39.164a.998.998 0 0 1-.984.835h-2.369A8.994 8.994 0 0 1 57.851 47c0 4.962-4.028 9-8.978 9-4.949 0-8.976-4.038-8.976-9a8.997 8.997 0 0 1 3.347-7.001H31.521c.126.637.226 1.284.293 1.943.07.727.104 1.399.104 2.058a1 1 0 0 1-.997 1 1 1 0 0 1-.998-1c0-.594-.031-1.203-.094-1.861C28.896 32.94 21.315 26 12.194 26a17.38 17.38 0 0 0-10.593 3.573.996.996 0 0 1-1.397-.193 1 1 0 0 1 .193-1.401 19.381 19.381 0 0 1 7.632-3.52.873.873 0 0 1-.149-.46v-23C7.88.447 8.427 0 8.978 0h19.948c.397 0 .757.236.915.6l9.843 22.7 7.195 1.048v-6.115c0-2.886 2.238-5.234 4.987-5.234.552 0 .998.448.998 1 0 .553-.446 1-.998 1-1.65 0-2.992 1.451-2.992 3.234v6.406l10.117 1.474a.995.995 0 0 1 .841 1.154l-1.976 11.897zM41.892 47c0 3.86 3.132 7 6.981 7 3.85 0 6.983-3.14 6.983-7s-3.133-7.001-6.983-7.001c-3.849 0-6.981 3.141-6.981 7.001zM28.272 2H9.88v20.999h27.499L28.272 2zm9.208 22.999H18.374c6.002 1.996 10.749 6.826 12.646 13.033.054-.009.104-.032.161-.032h24.845l1.671-10.055-20.217-2.946zm-24.513 5c7.15 0 12.966 5.833 12.966 13C25.933 50.168 20.117 56 12.967 56 5.818 56 .001 50.168.001 42.999c0-7.167 5.817-13 12.966-13zm0 24.001c6.049 0 10.971-4.935 10.971-11.001 0-6.065-4.922-11-10.971-11s-10.971 4.935-10.971 11C1.996 49.065 6.918 54 12.967 54z","key":1})]);
}

Tractor60px.displayName = "Tractor60px";

Tractor60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.82 56"};

module.exports = Tractor60px;

Tractor60px.default = Tractor60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/tractor-60px.svg
// module id = 1220
// module chunks = 0